<template>
	<div class="index_main">
		<div class="main">
			<div class="main_title">
				<div class="title">contact us</div>
				<div class="subtitle"><span></span>联系我们<span></span></div>
			</div>
			<div class="contact">
				<div>电话：{{about.tel}}</div>
				<div>邮箱：{{about.email}}</div>
				<div>地址：{{about.address}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mixins from '@/mixins/index'
	export default {
		mixins: [mixins],
		data() {
			return {
				about: ''
			}
		},
		mounted() {
			this.handindex()
		},
		methods: {
			handindex() {
				this.request({
					url: '/index/guanwang/contact_us',
					data: {},
					success: (res) => {
						if (res.code == 200) {
							this.about = res.data
						}
					}
				})
	
			}
		}
	}
</script>

<style lang="scss" scoped>
	.index_main {
		position: relative;
		display: flex;
		align-items: center;
		flex-direction: column;
		.main {
			max-width: 1200px;
			width: 100%;
			display: flex;
			align-items: center;
			flex-direction: column;
			.main_title {
				display: flex;
				flex-direction: column;
				align-items: center;
				padding: 30px 0;
			
				.title {
					display: flex;
					align-items: center;
					justify-content: space-between;
					font-size: 26px;
					color: #333;
					font-weight: bold;
			
				}
				.subtitle {
					display: flex;
					align-items: center;
					font-size: 24px;
					font-weight: 400;
					color: #333;
					margin-top: 20px;
					span{
						display: block;
						width: 80px;
						height: 1px;
						background: #000000;
						margin: 0 40px;
					}
				}
			}
			
			.contact {
				width: 610px;
				height: 210px;
				background: #E6F0FF;
				border: 1px solid #2D82FF;
				display: flex;
				align-items: center;
				flex-direction: column;
				font-size: 28px;
				color: #000000;
				margin-top: 40px;
				margin-bottom: 220px;
				line-height: 64px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/about/contact.vue